import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import SellerLayout from "@/components/SellerLayout";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { PageHeader, LoadingSkeleton, EmptyState } from "@/components/ui-system";
import { Globe } from "lucide-react";
import { toast } from "sonner";

// Seller-facing reference view of Delhivery's zone definition. The lane an order
// travels (origin zone → destination zone) is derived from the pickup and drop
// STATE. This page is reference data only — it carries no cost or rate figures.
const ZoneDefinition = ({ user, onLogout }) => {
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/rate-validation/zone-definition`)
      .then((r) => setZones(r.data.zones || []))
      .catch((e) => toast.error(e.response?.data?.detail || "Failed to load zone definition"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <SellerLayout user={user} onLogout={onLogout}>
      <div className="space-y-6 w-full">
        <PageHeader
          title="Zone Definition"
          subtitle="How states map to shipping zones. Your order's lane runs from the pickup state's zone to the drop state's zone."
        />

        {loading ? (
          <LoadingSkeleton />
        ) : zones.length === 0 ? (
          <EmptyState icon={Globe} title="No zones" description="Zone definition is unavailable right now." />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {zones.map((z) => (
              <Card key={z.zone} className="border-0 shadow-sm">
                <CardHeader className="pb-2">
                  <CardTitle className="flex items-center justify-between text-base">
                    <span className="flex items-center gap-2">
                      <Globe className="w-4 h-4" style={{ color: "#00A699" }} />
                      {z.label}
                    </span>
                    <Badge className="bg-[#00A699] bg-opacity-10 text-[#00A699] border border-[#00A699]">{z.zone}</Badge>
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="flex flex-wrap gap-1.5">
                    {z.states.map((s) => (
                      <Badge key={s} variant="outline" className="text-xs font-normal">{s}</Badge>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </SellerLayout>
  );
};

export default ZoneDefinition;
